<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm7 py-0 pt-1>
          <h1 class="headline font-weight-thin">{{config.title}}</h1>
        </v-flex>
        <v-flex xs12 sm5 py-0 text-xs-left text-sm-right pt-1>
          <div class="font-weight-thin">Registros: {{config.transactions.length}}</div>
          <div class="font-weight-thin">Valor total: {{transactionsTotalValue}}</div>
        </v-flex>
        <v-flex xs12 pa-0>
          <v-text-field v-model="transactionsFilter" class="search-filter" append-icon="search"></v-text-field>
        </v-flex>

        <transaction :record="transaction" v-for="transaction in config.transactions" :key="transaction.id" />

      </v-layout>
    </v-container>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" >
            EXIBIR MAIS
          </v-btn>
          <slot></slot>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
import WireTransactionItem from "./WireTransactionItem"

export default {
  name: 'WireTransactionList',
  components: { 'transaction': WireTransactionItem },
  props: {
    config: {
      type: Object
    }
  },
  data() {
    return {
      transactionsFilter: '',
      showMoreBtn: false
    }
  },
  computed: {
    transactionsTotalValue() {
      const total_value = this.config.transactions.reduce( ( acc, record ) => acc + (record.value * 1.0), 0 )
      let currency = (total_value > 0) ? this.config.transactions[0].currency : ''
      return `${total_value} ${currency}`
    }
  }
}
</script>
<style>
  .search-filter .v-icon {
    color: #CCC!important;
  }
  .search-filter .v-text-field__slot input {
    color: #AAA!important;
  }
</style>



// WEBPACK FOOTER //
// src/WireTransactionList.vue